<br>
<div>
    <div class="textBlock">
        <div>
            <p class="h2 text-center">Halte 4</p>
            <hr>
        </div>
        <div>
            <div class="text-center">
                <p class="h4 text-center">
                    Historie
                </p>
                <hr>
                <p class="text-center d-block margin">
                    Dat het speeltuintje ook voor de chiro een leuke speelplek is, hoef ik je niet te vertellen. Volgens de oudste plannen van Bloemendaal was hier eigenlijk een kerk voorzien. Tja, dan hebben wij toch liever dit speeltuintje. Die kerk kwam uiteindelijk tussen de school en de chirolokalen. Maar intussen is ze ook daar al een paar jaar verdwenen.                 
                </p>
                <p class="text-center d-block margin">
                    Van in dit speeltuintje is de vaart vlakbij. Daar was tot twee jaar geleden jaarlijks de Vlottentocht. De verschillende jeugdbewegingen van Schoten raceten daar tegen mekaar op zelfgemaakte vlotten. Zalig. Chiro Bloemendaal was zelden de snelste. Maar we sleepten wel een paar keer prijzen in de wacht voor de mooiste of creatiefste vlotten. Of de fair-playbeker. Da’s misschien nog wel de belangrijkste.                 
                </p>
                <img src="https://www.schoten.be/sites/default/files/public/afbeeldingen/vlottentocht_jeugddienst11.jpg" alt="vlottentocht.jpg">
                <p class="text-center d-block margin">
                    Hebben jullie ooit meegedaan aan de vlottentocht? Of ging je wel eens kijken?                
                </p>
                <p class="text-center d-block margin">
                    Of misschien heb je ooit nog wel gezwommen in de vaart? Die verhalen willen we dan graag horen!                
                </p>
            </div>
            <hr class="afterImage">
            <p class="h4 text-center">
                Navigatie
            </p>
            <hr>
            <p class="text-center d-block margin">
                Wandel intussen een kort stukje langs de vaart tot aan de eerste straat rechts (de Krokuslaan). Draai op het einde linksaf de Tulpenlaan in. Naast het eerste huis op je rechterkant zie je de brandweg.              
            </p>
        </div>
    </div>
    <div class="text-center buttonMargin">
        <button type="button" class="btn btn-primary" [routerLink]="'/halte5'">Volgende stop</button>
    </div>
</div>